// extracted by mini-css-extract-plugin
export default {"fixed":"LayoutFixed__fixed___3YLQV","left":"LayoutFixed__left___2xVmf LayoutFixed__fixed___3YLQV","right":"LayoutFixed__right___tkt2z LayoutFixed__fixed___3YLQV"};